import { useState } from 'react'
import { Button } from '@/components/ui/button'
import { ConfirmDialog } from '@/components/ui/ConfirmDialog'
import { CVC_OPTIONS } from '@/lib/statOptions'

interface ExchangeStep2Props {
    formData: any
    onSubmit: (data: any) => void
    onBack: () => void
    onNavigateHome: () => void
    showConfirm: boolean
    onConfirmNavigateHome: () => void
    onCancelConfirm: () => void
}

export const ExchangeStep2 = ({
    formData,
    onSubmit,
    onBack,
    onNavigateHome,
    showConfirm,
    onConfirmNavigateHome,
    onCancelConfirm
}: ExchangeStep2Props) => {
    const [cvc, setCvc] = useState({
        corps: formData.cvc?.corps || "3: Propre et soigné",
        vetements: formData.cvc?.vetements || "3: Cohérents, propres et en bon état",
        comportement: formData.cvc?.comportement || "3: Normal"
    })

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault()
        onSubmit(cvc)
    }

    const handleBack = () => {
        onBack()
    }

    const { corps, vetements, comportement } = CVC_OPTIONS

    return (
        <div className="min-h-screen bg-gray-50 py-8">
            <div className="max-w-4xl mx-auto px-4">
                <h1 className="text-3xl font-bold text-gray-900 mb-8">Score CVC</h1>

                <form onSubmit={handleSubmit} className="bg-white rounded-lg shadow p-8">
                    <div className="space-y-8">
                        <div>
                            <h3 className="text-lg font-semibold text-gray-900 mb-4">Corps</h3>
                            <div className="space-y-2">
                                {corps.map(option => (
                                    <label key={option} className="flex items-start">
                                        <input
                                            type="radio"
                                            name="corps"
                                            value={option}
                                            checked={cvc.corps === option}
                                            onChange={(e) => setCvc({ ...cvc, corps: e.target.value })}
                                            className="mr-3 mt-1"
                                        />
                                        <span className="text-sm">{option}</span>
                                    </label>
                                ))}
                            </div>
                        </div>

                        <div>
                            <h3 className="text-lg font-semibold text-gray-900 mb-4">Vêtements</h3>
                            <div className="space-y-2">
                                {vetements.map(option => (
                                    <label key={option} className="flex items-start">
                                        <input
                                            type="radio"
                                            name="vetements"
                                            value={option}
                                            checked={cvc.vetements === option}
                                            onChange={(e) => setCvc({ ...cvc, vetements: e.target.value })}
                                            className="mr-3 mt-1"
                                        />
                                        <span className="text-sm">{option}</span>
                                    </label>
                                ))}
                            </div>
                        </div>

                        <div>
                            <h3 className="text-lg font-semibold text-gray-900 mb-4">Comportement</h3>
                            <div className="space-y-2">
                                {comportement.map(option => (
                                    <label key={option} className="flex items-start">
                                        <input
                                            type="radio"
                                            name="comportement"
                                            value={option}
                                            checked={cvc.comportement === option}
                                            onChange={(e) => setCvc({ ...cvc, comportement: e.target.value })}
                                            className="mr-3 mt-1"
                                        />
                                        <span className="text-sm">{option}</span>
                                    </label>
                                ))}
                            </div>
                        </div>
                    </div>

                    <div className="flex justify-between mt-8">
                        <Button type="button" variant="outline" onClick={handleBack}>
                            Retour
                        </Button>
                        <div className="space-x-4">
                            <Button type="button" variant="outline" onClick={onNavigateHome}>
                                Accueil
                            </Button>
                            <Button type="submit">
                                Suivant
                            </Button>
                        </div>
                    </div>
                </form>
            </div>

            {showConfirm && (
                <ConfirmDialog
                    onConfirm={onConfirmNavigateHome}
                    onCancel={onCancelConfirm}
                />
            )}
        </div>
    )
} 